<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-8">
          <div v-html="data.startpage.bulletList"></div>
          <div v-if="!isPhone" class="clearfix--mid"></div>
          <div v-if="isPhone">
            <button class="btn btn-primary btn-md btn-pulse" style="min-width: 150px"
                    @click="$router.push('/scr-s')" v-html="data.startpage.healthAnalysisBtnText"></button>
            <div class="clearfix"></div>
            <button class="btn btn-primary btn-md" style="min-width: 150px"
                    @click="$router.push('/scr-r')" v-html="data.startpage.referralBtnText"></button>
            <div class="clearfix"></div>
          </div>
          <div :class="!isPhone ? 'row-imgs' : ''" class="row" v-show="!imgsLoaded">
            <div class="col-sm-3">
              <img src="https://via.placeholder.com/300?text=..." class="img-thumbnail img-responsive" alt="">
            </div>
            <div class="col-sm-5">
              <img src="https://via.placeholder.com/300?text=..." class="img-thumbnail img-responsive" alt="">
            </div>
            <div class="col-sm-3">
              <img src="https://via.placeholder.com/300?text=..." class="img-thumbnail img-responsive" alt="">
            </div>
          </div>
          <div :class="!isPhone ? 'row-imgs' : ''" class="row" v-show="imgsLoaded">
            <div class="col-sm-3">
              <img :src='"@/assets/img/gallery/" + img1 + ".jpg"'
                   class="img-thumbnail img-responsive" alt="Gallery image">
            </div>
            <div class="col-sm-5">
              <img :src='"@/assets/img/gallery/" + img2 + ".jpg"'
                   class="img-thumbnail img-responsive" alt="Gallery image">
            </div>
            <div class="col-sm-3">
              <img :src='"@/assets/img/gallery/" + img3 + ".jpg"'
                   class="img-thumbnail img-responsive" alt="Gallery image">
            </div>
          </div>
          <div v-if="!isPhone" class="clearfix--mid"></div>
          <button v-if="!isPhone" class="btn btn-primary btn-md btn-pulse" style="min-width: 150px"
                  @click="$router.push('/scr-s')" v-html="data.startpage.healthAnalysisBtnText"></button>
          <div v-if="!isPhone" class="clearfix--mid"></div>
          <button  v-if="!isPhone" class="btn btn-primary btn-md" style="min-width: 150px"
                  @click="$router.push('/scr-r')" v-html="data.startpage.referralBtnText"></button>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-lg col-middle">
          <div v-html="data.startpage.orderedList"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-5">
          <div v-html="data.startpage.loginBelowText"></div>
          <button class="btn btn-primary btn-md" style="min-width: 150px"
            @click="$router.push('/login-tr')" v-html="data.startpage.loginResultsBtnText"></button>
          <div class="clearfix"></div>
          <div v-html="data.startpage.asteriskText"></div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'startpage',
  components: {},
  data () {
    return {
      data: null,
      language: sessionStorage.getItem('language'),
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      isPhone: isMobile,
      imgsLoaded: false,
      img1: null,
      img2: null,
      img3: null,
      temp: {
        givenName: '',
        surName: '',
        sessionID: 'temp-s-id',
        ssn: '',
        invitationLink: ''
      }
    }
  },
  methods: {
    clearSessionStorage () {
      if (this.isDev || this.isQa) {
        sessionStorage.clear()
        const res = {
          ...sessionStorage
        }
        console.log('sessionStorage should be cleared, current: ' + JSON.stringify(res))
      }
    },
    clearLocalStorage () {
      if (this.isDev || this.isQa) {
        localStorage.clear()
        const res = {
          ...localStorage
        }
        console.log('localStorage should be cleared, current: ' + JSON.stringify(res))
      }
    },
    clearStorages () {
      this.clearSessionStorage()
      this.clearLocalStorage()
    },
    generateImage () {
      const array = [1, 2, 3, 4, 5]
      for (var i = array.length - 1; i >= 0; i--) {
        this.img1 = array.splice(Math.floor(Math.random() * array.length), 1)[0]
        this.img2 = array.splice(Math.floor(Math.random() * array.length), 1)[0]
        this.img3 = array.splice(Math.floor(Math.random() * array.length), 1)[0]
        break
      }
    }
  },
  updated () {
    // Fires after the DOM is created (and updated) and waits for one tick
    this.$nextTick(() => {
      setTimeout(() => (this.imgsLoaded = true))
    })
  },
  beforeMount () {
    this.generateImage()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          startpage(locale: ` + sessionStorage.getItem('language') + `) {
            bulletList
            orderedList
            loginBelowText
            asteriskText
            healthAnalysisBtnText
            referralBtnText
            loginResultsBtnText
          }
        }
      `
    })
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
#asterisk--1:target {
  text-decoration: underline;
  -webkit-text-decoration-color: rgba(0, 0, 0, 0.2);
  text-decoration-color: rgba(0, 0, 0, 0.2);
}
#asterisk--2:target {
  text-decoration: underline;
  -webkit-text-decoration-color: rgba(0, 0, 0, 0.2);
  text-decoration-color: rgba(0, 0, 0, 0.2);
}
button:disabled {
  opacity: 0.3;
}
.alert-error {
  display: none;
}
.container {
  padding-bottom: 3vh;
}
.col-middle {
  margin-top: 4vh;
  margin-bottom: 4vh;
  background: rgba(0, 128, 0, 0.212);
  padding: 4vh 22vw 2.5vh 22vw;
  color: #47743b;
}
.row-imgs {
  margin-left: 4vw;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
  .col-middle {
    margin-top: 5vh;
    margin-bottom: 5vh;
    background: rgba(0, 128, 0, 0.212);
    padding: 3vh 10vw 1vh 10vw;
    color: #47743b;
  }
}
.m-top {
  margin-left: 35px;
  margin-top: 100px;
  position: absolute;
  width: 400px;
  z-index: 999;
}
.dev {
  margin-left: 35px;
  margin-top: 25px;
  float: left;
  cursor: pointer;
}
.dev > button {
  border-radius: 5px;
  border: 1px solid #069ccc;
  padding: 8px;
}
.btn-pulse {
  box-shadow: 0 0 0 0 rgba(187, 187, 187, 0.7);
  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  transition: all 300ms ease-in-out;
}
.btn-pulse:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
  color: #ffffff;
}
@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}

@keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Startpage.vue